import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import Loading from "../../loading/Loading";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import axios from "axios";
import { FiFileText, FiPackage, FiDollarSign, FiArchive, FiToggleRight, FiGrid, FiImage } from 'react-icons/fi';
import FormWizard from '../../ui/FormWizard';
import { InputField, SelectField, FileField, FormRow } from '../../ui/InputField';

const AlterarProduto = () => {
    const [codigo, setCodigo] = useState("");
    const [descricao, setDescricao] = useState("");
    const [idUnidade, setIdUnidade] = useState("");
    const [preco, setPreco] = useState("");
    const [status, setStatus] = useState("");
    const [estoque, setEstoque] = useState("");
    const [tipo, setTipo] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const parametro = useParams();
    const [unidadeBd, setUnidadeBd] = useState([]);
    const [imagem, setImagem] = useState(null);

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    useEffect(() => {
        fetch(Apis.urlListarUnidades, {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: `${localStorage.getItem("token")}` },
            body: JSON.stringify(""),
        }).then(r => r.json()).then(result => setUnidadeBd(result.registros));
    }, []);

    useEffect(() => {
        setLoading(true);
        fetch(Apis.urlListarOneProdutos, {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: `${localStorage.getItem("token")}` },
            body: JSON.stringify({ id: parametro.id }),
        }).then(r => r.json()).then(result => {
            if (result.retorno.sucesso) {
                setCodigo(result.registros[0].codigo);
                setDescricao(result.registros[0].descricao);
                setIdUnidade(result.registros[0].unidade_id);
                setPreco(result.registros[0].preco);
                setStatus(result.registros[0].status);
                setEstoque(result.registros[0].estoque);
                setTipo(result.registros[0].tipo);
            } else {
                alertaErro(result.retorno.mensagem);
                navigate("/listar-produtos");
            }
            setLoading(false);
        });
    }, []);

    const handleSubmit = async () => {
        if (codigo === "" || descricao === "" || idUnidade === "" || preco === "" || status === "" || estoque === "" || tipo === "") {
            alertaErro("Todos os campos devem ser preenchidos!");
            return;
        }
        setLoading(true);
        const data = new FormData();
        data.append("id", parametro.id);
        data.append("meu_id", 0);
        data.append("codigo", codigo);
        data.append("descricao", descricao);
        data.append("unidade_id", idUnidade);
        data.append("preco", preco);
        data.append("status", status);
        data.append("estoque", estoque);
        data.append("tipo", tipo);
        if (imagem) data.append("imagem", imagem);

        await axios.post(Apis.urlAlterarProduto, data, {
            headers: { "Content-Type": "multipart/form-data", Authorization: `${localStorage.getItem("token")}` }
        }).then(response => {
            showAlert({ title: "Sucesso", text: response.data.retorno.mensagem, icon: "success" });
            navigate(-1);
        }).catch(error => {
            alertaErro(error.response?.data?.retorno?.mensagem || "Erro ao alterar produto");
        }).finally(() => setLoading(false));
    };

    if (idUnidade === "cadastrarUnidade") navigate(`/cadastrar-unidade/${parametro.id}`);
    if (loading) return <Loading />;

    return (
        <FormWizard
            title="Alteração de Produto"
            icon={<FiPackage />}
            steps={['Dados do Produto', 'Preço & Imagem']}
            onSubmit={handleSubmit}
            submitLabel="Salvar Alterações"
        >
            {/* Passo 1 — Dados do Produto */}
            <>
                <InputField label="Descrição" icon={<FiFileText />} required
                    placeholder="Descrição" onChange={e => setDescricao(e.target.value)} value={descricao} />
                <FormRow>
                    <InputField label="Preço" icon={<FiDollarSign />} required
                        type="number" placeholder="0,00"
                        onChange={e => setPreco(e.target.value)} value={preco} />
                    <InputField label="Quantidade em estoque" icon={<FiArchive />} required
                        placeholder="Quantidade"
                        onChange={e => setEstoque(e.target.value)} value={estoque} />
                </FormRow>
                {unidadeBd ? (
                    <SelectField label="Unidade" icon={<FiPackage />}
                        onChange={e => setIdUnidade(e.target.value)} value={idUnidade}>
                        <option value="vazio">— selecione a unidade —</option>
                        {unidadeBd.map(u => (
                            <option value={u.id} key={u.id}>{u.sigla}</option>
                        ))}
                        <option value="cadastrarUnidade">Cadastrar unidade</option>
                    </SelectField>
                ) : (
                    <Link to={`/cadastrar-unidade/${parametro.id}`}>
                        <button type="button" style={{ width: '100%', height: 44, borderRadius: 4, background: 'linear-gradient(135deg, #3d7a9c, #1e3a4c)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                            Cadastrar Unidade
                        </button>
                    </Link>
                )}
            </>

            {/* Passo 2 — Status & Imagem */}
            <>
                <FormRow>
                    <SelectField label="Status" icon={<FiToggleRight />}
                        onChange={e => setStatus(e.target.value)} value={status}>
                        <option value="">— selecione o status —</option>
                        <option value="0">Ativo</option>
                        <option value="1">Inativo</option>
                    </SelectField>
                    <SelectField label="Tipo" icon={<FiGrid />}
                        onChange={e => setTipo(e.target.value)} value={tipo}>
                    <option value="">— selecione o tipo —</option>
                    <option value="0">Mercadoria para Revenda</option>
                    <option value="1">Matéria-Prima</option>
                    <option value="2">Embalagem</option>
                    <option value="3">Produto em Processo</option>
                    <option value="4">Produto Acabado</option>
                    <option value="5">Subproduto</option>
                    <option value="6">Produto Intermediário</option>
                    <option value="7">Material de Uso e Consumo</option>
                    <option value="8">Ativo Imobilizado</option>
                    <option value="9">Serviços</option>
                    <option value="10">Outros insumos</option>
                    <option value="99">Outras</option>
                    </SelectField>
                </FormRow>
                <FileField label="Imagem do produto"
                    accept="image/*"
                    onChange={e => setImagem(e.target.files[0])} />
            </>
        </FormWizard>
    );
};

export default AlterarProduto;
